export default "<div class=\"container\">\n    <header>\n        <div class=\"logo\" (click)=\"onClick()\">云课堂</div>\n    </header>\n</div>\n\n";